import { make } from 'vuex-pathify';
import { AuthService } from '@/services/auth';
import { TokenService } from '@/services/token';
import { errorCatch } from '../utils';
import router from '@/router/';

const tokenService = new TokenService();
const authService = new AuthService();

export const state = {
  userInfo: localStorage.getItem('user') || null,
  verified: false,
  passwordChanged: false,
  loggedin: localStorage.getItem('user'),
  service: new AuthService(),
  loading: false,
  error: {}
};

export const mutations = {
  ...make.mutations(state),

  SET_ERROR(state: any, error: any) {
    errorCatch(state, error);
  },

  CLEAR_ERROR(state: any) {
    state.error = {};
  }
};

export const actions = {
  clearError: ({ commit }: any) => commit('CLEAR_ERROR'),

  login: async ({ commit, dispatch }: any, payload: any) => {
    dispatch('clearError');
    commit('SET_LOADING', true);

    await new Promise((resolve, reject) => {
      authService
        .login(payload.email, payload.password)
        .then(({ user, token, tokenData }) => {
          commit('accounts/SET_CURRENT_USER', user, { root: true });
          localStorage.setItem('user', JSON.stringify(tokenData));
          localStorage.setItem('access__token', token); //TODO: check logic for login as it seems to set token in service and also in store

          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },

  logout: async ({ commit, dispatch }: any) => {
    dispatch('clearError');
    commit('SET_LOADING', true);
    await new Promise((resolve, reject) => {
      authService
        .logout()
        .then(() => {
          // window.localStorage.clear();
          localStorage.removeItem('user');
          localStorage.removeItem('access__token');
          // window.sessionStorage.clear();
          setTimeout(() => {
            router.push({
              name: 'sign-in'
            });
          }, 1000);
          resolve();
        })
        .catch(err => {
          console.log(err);

          commit('SET_ERROR', err);
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },

  // TODO: These should all be moved to accounts module
  verifyEmail: async ({ commit, dispatch }: any, payload: any) => {
    dispatch('clearError');
    commit('SET_LOADING', true);
    await new Promise((resolve, reject) => {
      authService
        .confirmEmail(payload)
        .then(() => {
          commit('SET_VERIFIED', true);
          resolve();
        })
        .catch(err => {
          commit('SET_VERIFIED', false);
          commit('SET_ERROR', err);
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },

  requestEmail: async ({ commit, dispatch }: any, payload: any) => {
    dispatch('clearError');
    commit('SET_LOADING', true);
    await new Promise((resolve, reject) => {
      authService
        .verifyEmail(payload)
        .then(() => {
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },

  forgotPassword: async ({ commit, dispatch }: any, payload: any) => {
    dispatch('clearError');
    commit('SET_LOADING', true);
    await new Promise((resolve, reject) => {
      authService
        .forgotPassword(payload)
        .then(() => {
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },

  passwordConfirm: async ({ commit, dispatch }: any, payload: any) => {
    dispatch('clearError');
    commit('SET_LOADING', true);
    await new Promise((resolve, reject) => {
      authService
        .passwordConfirm(payload.uid, payload.token)
        .then(() => {
          resolve();
        })
        .catch(err => {
          commit('SET_ERROR', err);
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  },

  passwordResetConfirm: async ({ commit, dispatch }: any, payload: any) => {
    console.log(payload);

    dispatch('clearError');
    commit('SET_LOADING', true);
    await new Promise((resolve, reject) => {
      authService
        .passwordResetConfirm(payload)
        .then(() => {
          commit('SET_PASSWORD_CHANGED', true);
          resolve();
        })
        .catch(err => {
          console.log(err);
          commit('SET_ERROR', err);
          reject();
        })
        .finally(() => {
          commit('SET_LOADING', false);
        });
    });
  }
};

export const getters = {
  getUserInfo: (state: any) => state.userInfo,
  getLoading: (state: any) => state.loading,
  isLoggedin: (state: any) => {
    try {
      return !!tokenService.isExpired(JSON.parse(state.userInfo).exp);
    } catch (e) {
      return false;
    }
  },
  isVerified: (state: any) => state.verified,
  getAuthError: (state: any) => state.error
};
